export class ReleaseInfo {
  public version: string;
  public name: string;
  public path: string;
  public date: Date;
  public changelog: string;
  public note: string;
  public machines: string[];
  public files: ReleaseFile[];
  public upgradeCondition: string;

  public constructor(data: any) {
    this.version = data.version;
    this.name = data.name;
    this.path = data.path;
    this.date = new Date(data.date);
    this.changelog = data.changelog;
    this.note = data.note;
    this.machines = data.machines;
    this.upgradeCondition = data['upgrade-condition'];

    this.files = [];
    for (const file of data.files) {
      this.files.push(new ReleaseFile(file));
    }
  }
}

export class ReleaseFile {
  public machines: string[];
  public type: ReleaseFileType;
  public url: string;
  public sha256: string;
  public size: number;

  public constructor(data: any) {
    this.machines = data.machines;
    this.type = data.type;
    this.url = data.url;
    this.sha256 = data.sha256;
    this.size = data.size;
  }
}

export enum ReleaseFileType {
  Artifact = 'artifact',
  Image = 'image',
}
